import { Divider } from '@material-ui/core'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import { withStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import classNames from 'classnames'
import React from 'react'

const styles = theme => ({
  root: {
    // marginBottom: theme.spacing(4),
    paddingTop: '10px',
    // padding: theme.spacing(4),
    minHeight: '100px',
    width: '100%',
  },
  container: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    border: '1px solid #ccc',
    boxShadow: 'none',
    borderRadius: '4px !important',
  },
  borderBottomNone: {
    borderBottom: 'none',
  },
  containerWithDisable: {
    width: '100%',
    pointerEvents: 'none',
    border: 'solid 1px #ccc',
    boxShadow: 'none',
    /* for "disabled" effect */
    // opacity: '0.5',
    backgroundColor: theme.accordion.disabledBg,
  },
  heading: {
    fontSize: theme.accordion.headingFontSize,
    fontWeight: theme.accordion.headingFontWeight,
    color: theme.accordion.darkest,
  },
  subHeading: {
    paddingTop: theme.spacing(4),
    // width: '42%',
  },
  subParent: {
    paddingTop: theme.spacing(4),
    // width: '42%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    color: theme.accordion.subHeadingColor,
    fontSize: theme.accordion.subHeadingFontSize,
  },
  expand: {
    float: 'right',
  },
  title: {
    width: '50%',
    paddingRight: theme.spacing(4),
  },
  epSummary: {
    width: '42%',
  },
  backgroundWhite: {
    backgroundColor: theme.colors.white,
  },
  padding10: {
    padding: theme.spacing(4),
  },
  rightTopHead: {
    width: 'auto',
    padding: 0,
    textAlign: 'right',
  },
  rightTopHeadWrap: {
    width: '50%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    paddingRight: '0 !important',
  },
  fullwidth: {
    width: '100%',
  },
  divide: {
    paddingLeft: '0',
    paddingRight: '0',
    marginBottom: '30px',
  },
})

class Accordion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      expansionPanelOpen: props.expanded ? props.expanded : false,
      // buttonName: '',
    }
  }

  componentWillReceiveProps(nextProps) {
    const { expanded } = nextProps
    const { expansionPanelOpen } = this.state
    if (expanded !== this.props.expanded) {
      this.setState({
        expansionPanelOpen: !expansionPanelOpen,
      })
    }
  }

  toggleExpansionPanel = () => {
    const { expansionPanelOpen } = this.state
    this.setState({
      expansionPanelOpen: !expansionPanelOpen,
    })
  }

  render() {
    const {
      classes,
      label,
      subLabel,
      children,
      isDisable,
      expandIcon,
      expandIconCompnent,
      sideLabel,
      headText,
      headStyles,
    } = this.props

    return (
      <div className={classes.root}>
        <ExpansionPanel
          className={isDisable ? classes.containerWithDisable : classes.container}
          expanded={this.state.expansionPanelOpen}
          onClick={this.toggleExpansionPanel}
        >
          <ExpansionPanelSummary
            style={headStyles}
            className={classes.borderBottomNone}
            expandIcon={
              // eslint-disable-next-line no-nested-ternary
              expandIcon ? expandIconCompnent || <ExpandMoreIcon /> : null
            }
          >
            <div className={classNames(classes.title)}>
              {headText && headText}
              <div className={classes.heading}>{label}</div>
              {subLabel && <div className={classes.subParent}>{subLabel}</div>}
            </div>
            {sideLabel && (
              <div className={classes.rightTopHeadWrap}>
                <div className={classes.rightTopHead}>{sideLabel}</div>
              </div>
            )}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className={classNames(classes.backgroundWhite, classes.fullwidth)}>
              <Divider className={classes.divide} />
              {children}
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    )
  }
}

Accordion.defaultProps = {
  headStyles: {},
  expanded: false,
}

const AccordionComponent = withStyles(styles)(Accordion)
AccordionComponent.displayName = 'Accordion'
export default AccordionComponent
